import MuiListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';

export interface IListItemIconProps extends ListItemIconProps {}

const ListItemIcon = (props: IListItemIconProps): JSX.Element => {
  return <MuiListItemIcon {...props} />;
};

export default ListItemIcon;
